import PropTypes from 'prop-types'
import React, { Component } from 'react'
import DateTime from 'react-datetime'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Field } from 'redux-form'
import moment from 'moment-timezone'
import 'react-datetime/css/react-datetime.css'
import { get } from 'lodash'

import { FieldError } from 'components/misc'
import fieldId from 'constants/layout/fieldId'
import styles from './input-date.styl' // eslint-disable-line

@injectIntl
class InputDate extends Component {
  static propTypes = {
    intlKey: PropTypes.string,
    intl: PropTypes.object,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    minDay: PropTypes.object,
    maxDay: PropTypes.object,
    minToday: PropTypes.bool,
    maxToday: PropTypes.bool,
    disabled: PropTypes.bool,
    validate: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.arrayOf(PropTypes.func)
    ]),
    yearsInAdvance: PropTypes.number,
    logs: PropTypes.bool
  }

  state = {
    editingValue: null,
    selectedDate: null,
    initialized: false,
    isValid: true,
    locale: moment.locale(),
    validate: () => {
    }
  }

  handleInputChange = input => {
    try {
      this.setState({ editingValue: input.target.value })
    }
    catch (error) {
      console.error(error)
    }
  }

  handleEdit = (newValue, field) => {
    try {
      if (this.state.locale) {
        moment.locale(this.state.locale)
      }
      const dateMoment = moment(newValue)
      const isValid = dateMoment.isValid()
      this.setState({ editingValue: newValue, isValid })

      if (isValid) {
        const dateWithTime =
          this.props.logs
            ? dateMoment
              .hour(0).minute(0).second(0)
            : dateMoment
              .hour(12).minute(0).second(0)

        const normalizedDate = dateWithTime
          .lang('en').format('YYYY-MM-DDTHH:mm:ss')

        if (this.state.locale) {
          moment.locale(this.state.locale)
        }

        return field.input.onChange(normalizedDate)
      }
      else {
        return field.input.onChange(null)
      }
    } catch (err) {
      console.error(err)
      return field.input.onChange(null)
    }
  }

  handleValidate = newValue => {
    const dateMoment = moment(newValue)
    const isValid = dateMoment.isValid()
    if (isValid && (dateMoment.isBefore('1900-01-01')
      || dateMoment.isAfter('2099-12-31')
    )) {
      return true
    }

    if (this.props.validate) {
      return this.props.validate(newValue)
    }
  }

  renderField = field => {
    const { meta, input } = field
    const { disabled, intl } = this.props
    const isError = (input.value || meta.touched) && meta.error
    const errorClass = (isError || !this.state.isValid) ? styles.error : ''

    let initialDate
    const initial = get(field, 'meta.initial')
    if (initial) {
      initialDate = moment(initial)
    } else if (get(field, 'input.value')) {
      initialDate = moment(get(field, 'input.value'))
    }

    if (initialDate && !this.state.initialized && !this.state.editingValue) {
      this.setState({
        initialized: true,
        editingValue: initialDate
      })
    }

    const placeholder = intl.formatMessage({
      id: 'label.date',
      defaultMessage: 'Date'
    })


    return (
      <div
        className={`${styles.controls} ${errorClass}`}
      >

        <DateTime
          id={this.key}
          value={this.state.editingValue}
          onChange={newValue => this.handleEdit(newValue, field)}
          closeOnSelect
          timeFormat={false}
          inputProps={{
            disabled,
            placeholder,
            onChange: this.handleInputChange
          }}
        />

        <FieldError toShow={isError} message={meta.error} />
      </div>
    )
  }

  render() {
    const { name, label, intlKey, disabled } = this.props

    return (
      <div
        className={`form-group ${styles.formGroup} ${disabled && styles.disabled}`}
        id={`${fieldId}.${name}`}
      >
        <label className='control-label'>
          {intlKey
            ? <FormattedMessage id={intlKey} defaultMessage={label} />
            : label}
        </label>

        <Field
          name={name}
          component={this.renderField}
          {...this.state}
          validate={this.handleValidate}
        />
      </div>
    )
  }
}

export default InputDate
